import { Input, Icon } from '@chakra-ui/react';
import debounce from 'lodash/debounce';
import { Search } from 'lucide-react';
import React, {
  useRef, useMemo, useEffect, useState,
} from 'react';

import { CloseButton } from '@chakra-snippets/close-button';
import { InputGroup } from '@chakra-snippets/input-group';

interface SearchInputProps {
  placeholder?: string;
  searchText: string;
  onChange: (value: string) => void;
  debounceTime?: number;
  showClearBtn? : boolean;
}

const SearchInput: React.FC<SearchInputProps> = ({
  placeholder = 'Search',
  searchText,
  onChange,
  debounceTime = 300,
  showClearBtn = true,
}) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [value, setValue] = useState(searchText);

  const debouncedSetSearch = useMemo(
    () => debounce((search: string) => {
      onChange(search);
    }, debounceTime),
    [onChange, debounceTime],
  );

  useEffect(() => {
    debouncedSetSearch(value);
  }, [value, debouncedSetSearch]);

  return (
    <InputGroup
      w="100%"
      borderRadius="md"
      flex="1"
      startElement={<Icon><Search /></Icon>}
      endElement={showClearBtn && (
        <CloseButton
          size="xs"
          onClick={() => {
            onChange('');
            setValue('');
            inputRef.current?.focus();
          }}
          me="-2"
        />
      )}
    >
      <Input
        placeholder={placeholder}
        value={value}
        onChange={(e) => setValue(e.target.value)}
      />
    </InputGroup>
  );
};

export default SearchInput;
